// extracted by mini-css-extract-plugin
export default {"suffix":"mKhPRp","invalid":"A3sImb"};